import { form } from '../../formState'

import { useTexts } from './hooks/useTexts'

type Option = {
  type: 'option'
  value: uui.domain.server.rm.VoiceConfig['status']
  label: string
}

export function StatusField() {
  const {
    meta: { submitting, disabled },
  } = form.useFormMeta()
  const formDisabled = submitting || disabled
  const texts = useTexts()

  const options: Option[] = [
    { type: 'option', value: 'OFF', label: texts.status.values.off },
    { type: 'option', value: 'BASIC', label: texts.status.values.basic },
    { type: 'option', value: 'ADVANCED', label: texts.status.values.advanced },
  ]

  return (
    <form.SimpleSelect
      testId="voice-status"
      label={texts.status.label}
      name="status"
      options={options}
      validateOn="blur change"
      disabled={formDisabled}
      selectProps={{
        MenuProps: {
          MenuListProps: {
            // @ts-expect-error
            ['data-trackid']: 'status-field__menu',
          },
        },
      }}
    ></form.SimpleSelect>
  )
}
